import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { ApiErrorHandlerService } from "../../utils/api-error-handler/api-error-handler.service";
import { Observable } from "rxjs";

import { RepairRequest } from "../../../models/api/fault/repairRequest";
import { OffsetPaginationDto } from "../../../models/api/pagination";

interface RepairRequestDataQuery {
  gateSystemId?: string;
  page: number;
  pageSize: number;
  excludeArchived?: boolean;
}

@Injectable({
  providedIn: "root",
})
export class RepairService {
  private http = inject(HttpClient);
  private apiErrorHandler = inject(ApiErrorHandlerService);

  /**
   * Updates the status of a repair request.
   * @param repairStatus - The new status to set for the repair request.
   * @param repairRequestId - The unique identifier of the repair request to update.
   * @returns An observable for the HTTP PUT request to update the repair status.
   */
  public changeRepairStatus(repairStatus: string, repairRequestId: string) {
    return this.http
      .put(environment.baseUrl + `/repairRequest/${repairRequestId}`, {
        status: repairStatus,
      })
      .pipe(this.apiErrorHandler.handle("repair_request"));
  }

  /**
   * Retrieves a paginated list of repair requests from the backend.
   * @param query Pagination and optional filter settings.
   * @returns An observable of one page of repair requests including pagination metadata.
   */
  public getRepairRequestData(query: RepairRequestDataQuery): Observable<OffsetPaginationDto<RepairRequest>> {
    let params = new HttpParams().set("page", query.page).set("pageSize", query.pageSize);

    if (query.gateSystemId) {
      params = params.set("gateSystemId", query.gateSystemId);
    }
    if (query.excludeArchived !== undefined) {
      params = params.set("excludeArchived", query.excludeArchived);
    }

    return this.http
      .get<OffsetPaginationDto<RepairRequest>>(`${environment.baseUrl}/repairRequest`, {
        params,
      })
      .pipe(this.apiErrorHandler.handle("repair_request"));
  }
}
